import { useCallback } from 'react';
import { useHttpClient } from '../../client/HttpClientContext';
import { useAsyncFunction } from '../../utils/hooks/useAsyncFunction';
import { conditionalPropertyOptionsRulesCache } from '../../cache';
export const useConditionalPropertyOptionsRulesForObjectType = (objectTypeId, options = {
  skip: false
}) => {
  const httpClient = useHttpClient();
  const getRules = useCallback(() => {
    return conditionalPropertyOptionsRulesCache.get(objectTypeId, httpClient);
  }, [httpClient, objectTypeId]);
  return useAsyncFunction(getRules, options);
};